import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NovoSuprimentoFormProvider } from 'src/app/providers';
import { ListaPaginada } from 'src/app/models';
import { Subscription } from 'rxjs';
import { AuthenticationService, EquipamentoService } from 'src/app/services';
import { IEquipamento } from 'src/app/interfaces';
import { EGrupoProduto } from 'src/app/enums';
import { IToken } from 'src/app/interfaces/token/IToken';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-novo-suprimento-a',
  templateUrl: './novo-suprimento-a.component.html',
  styleUrls: ['./novo-suprimento-a.component.scss']
})
export class NovoSuprimentoAComponent implements OnInit, OnDestroy {
  subscription$ = new Subscription();
  form!: FormGroup;
  equipamentoControl: FormControl;
  equipamentos = new ListaPaginada<IEquipamento>();
  token: IToken;

  constructor(
    private equipamentoService: EquipamentoService,
    private authenticationService: AuthenticationService,
    private novoSuprimentoFormProvider: NovoSuprimentoFormProvider,
    private router: Router
  ) {}

  //#region Controle input equipamento
  filtrarEquipamentos(
    valor: IEquipamento | string,
    dados: IEquipamento[]
  ): IEquipamento[] {
    return dados.filter(
      (v) =>
        v.numPat
          ?.toLowerCase()
          .includes(
            typeof valor === 'string'
              ? valor.toLowerCase()
              : valor.numPat?.toLowerCase()!
          ) ||
        v.numSerie
          ?.toLowerCase()
          .includes(
            typeof valor === 'string'
              ? valor.toLowerCase()
              : valor.numSerie!.toLowerCase()
          ) ||
        v.modelo
          ?.toLowerCase()
          .includes(
            typeof valor === 'string'
              ? valor.toLowerCase()
              : valor.modelo?.toLowerCase()!
          )
    );
  }

  exibirEquipamento(valor: IEquipamento) {
    if (valor !== null && Object.keys(valor).length > 0) {
      return `${valor?.numPat} - ${valor?.numSerie} | ${valor?.modelo}`;
    }
    return '';
  }

  valorEquipamento(valor: IEquipamento) {
    return valor;
  }

  comparaEquipamento(valor1: string | IEquipamento, valor2: IEquipamento) {
    if (typeof valor1 === 'string') {
      return false;
    }

    if (valor1.numSerie !== valor2.numSerie) {
      return false;
    }

    return true;
  }
  //#endregion

  obterEquipamentos() {
    this.subscription$.add(
      this.equipamentoService
        .getEquipamentos({
          idUsuario: this.token.id,
          CodContrato: this.token.codContrato,
          CodGrupoEconomico: this.token.codGrupoEconomico,
          TipoUsuario: this.token.tipoUsuario,
          contratoAtivo: true,
          equipamentoAtivo: true,
          paginar: false,
          GrupoProduto: EGrupoProduto.IMPRESSORA
        })
        .subscribe({
          next: ({ data }) => {
            this.equipamentos = data;
          }
        })
    );
  }
  prosseguir() {
    this.router.navigate(['/novo-suprimento/abrir-chamado/2']);
  }
  ngOnInit(): void {
    this.equipamentoControl = this.novoSuprimentoFormProvider
      .getForm()
      .get('equipamento') as FormControl;
    this.form = this.novoSuprimentoFormProvider
      .getForm()
      .get('primeiroPasso') as FormGroup;
    this.token = this.authenticationService.obterToken();
    this.obterEquipamentos();
  }
  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
